import { Inject, Injectable, DOCUMENT } from '@angular/core'
import { MediaMatcher } from '@angular/cdk/layout'
import { ThemeTypes } from '@app/shared/data-types/user.interface'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private mediaMatcher: MediaMatcher
  ) {}

  private currentTheme$: BehaviorSubject<ThemeTypes>

  set(theme: ThemeTypes): void {
    const systemTheme = this.mediaMatcher.matchMedia('(prefers-color-scheme: dark)')
    let newTheme = ThemeTypes.LIGHT

    if ((theme == ThemeTypes.SYSTEM && systemTheme.matches) || theme == ThemeTypes.DARK) {
      newTheme = ThemeTypes.DARK
    }

    if (this.currentTheme$) {
      this.currentTheme$.next(newTheme)
    } else {
      this.currentTheme$ = new BehaviorSubject<ThemeTypes>(newTheme)
    }

    this.toggleCSSClass(newTheme)

    systemTheme.onchange = () => {
      if (theme !== ThemeTypes.SYSTEM) {
        return
      }
      newTheme = newTheme === ThemeTypes.DARK ? ThemeTypes.LIGHT : ThemeTypes.DARK
      this.toggleCSSClass(newTheme)
      this.currentTheme$.next(newTheme)
    }
  }

  get(): Observable<ThemeTypes> {
    return this.currentTheme$
  }

  private toggleCSSClass(theme: ThemeTypes): void {
    if (theme == ThemeTypes.DARK) {
      this.document.children[0].classList.add('dark-theme')
    } else {
      this.document.children[0].classList.remove('dark-theme')
    }
  }
}
